import React, { useState, useEffect } from "react";
import { object, array, string } from "prop-types";
import { StoryElement, Link } from "@quintype/components";

import { getPollingStories } from "../../../helper/api";
import { getSlug } from "../../../utils/utils";

import Headline from "../../../atoms/Headline";
import RightArrowButton from "../../../atoms/icons/right-arrow-button";
import LeftArrowButton from "../../../atoms/icons/left-arrow-button";
import ScrollSnap from "../../../atoms/ScrollSnap";

import "./organism3.m.css";

const Organism3 = ({ collection, sections, domainSlug }) => {
  const [pollElements, setPollElements] = useState(null);
  const slug = getSlug(collection, sections, domainSlug);
  const storyFields =
    "headline,slug,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,published-at,story-template,metadata,cards";

  useEffect(() => {
    getPollingStories(collection.slug, storyFields).then(stories => {
      if (stories.length) {
        processPollElements(stories);
      }
    });
  }, []);

  // Get all the poll elements and create children/storyelements
  const processPollElements = stories => {
    const children = [];

    stories.forEach(({ story }) => {
      if (story["story-template"] === "polls" && story.cards && story.cards.length) {
        story.cards.forEach(card => {
          const cardElements = card["story-elements"];

          if (cardElements) {
            const pollElement = cardElements.find(element => element.type === "polltype");

            if (pollElement) {
              children.push(<StoryElement key={story.id} story={story} element={pollElement} />);
            }
          }
        });
      }
    });

    setPollElements(children);
  };

  if (!(pollElements && pollElements.length)) {
    return null;
  }

  return (
    <div styleName="wrapper">
      <Link href={slug}>
        <Headline
          text={collection.name}
          headlineType={4}
          headerLevel={2}
          headlineDesign="witharrow"
          className="collection-name-arrow"
        />
      </Link>
      <ScrollSnap leftArrow={<LeftArrowButton />} rightArrow={<RightArrowButton />}>
        {pollElements}
      </ScrollSnap>
    </div>
  );
};

Organism3.propTypes = {
  collection: object.isRequired,
  sections: array.isRequired,
  domainSlug: string
};

export default Organism3;
